export enum BenutzerTyp {
  Allgemein = 0,
  Mitarbeiter = 1,
  Partner = 2,
  PartnerMitarbeiter = 3,
  Dienstleister = 4,
  Admin = 5,
  Monteur = 6,
  UnterAdmin = 7,
  Projektleiter = 8,
  Fahrer = 9,
}

export enum TankanlagenTyp {
    Tankstelle = 1,
    Tankanlage = 2,
    Leihtank = 3,
    Sonstige = 4,
    Heizöl = 5
}

export enum Prioritaet {
    Niedrig = 0,
    Mittel = 1,
    Hoch = 2
}

export enum TicketStatus {
    Neu = 0,
    Geschlossen = 1,
    InBearbeitung = 2,
    NeuEroeffnet = 3,
    Aktiv = 4,
    Inaktiv = 5,
    Geloescht = 6
}

export enum MailArt {
    TicketErstellt = 0,
    TicketGeantwortet = 1,
    TicketGeloescht = 2,
    TicketGeschlossen = 3
}

export enum DokumentenTyp {
    Bestellung = 1,
    Auftragsbestaetigung = 2,
    Monteurauftrag = 3,
    Pruefbericht = 4,
    Sonstiges = 5,
    Wartungsvertrag = 6,
    Arbeitsbericht = 7,
    Angebote = 8,
    Auftraege = 9
}

export enum BildTyp {
    Tanktechnik = 1,
    Shop = 2,
    Gelaende = 3,
    Waschtechnik = 4,
    Sonstiges = 5,
    Elektrik = 6
}

export enum SchnittstellenProtokoll {
    Unbekannt = 0,
    ER3 = 1,
    TwoWire = 2,
    Impuls = 3
}

export function benutzerTypText(value: number | string | null | undefined): string {
  const n = typeof value === "string" ? Number(value) : (value ?? NaN);
  switch (n) {
    case BenutzerTyp.Allgemein: return "Allgemein";
    case BenutzerTyp.Mitarbeiter: return "Mitarbeiter";
    case BenutzerTyp.Partner: return "Partner";
    case BenutzerTyp.PartnerMitarbeiter: return "Partner-Mitarbeiter";
    case BenutzerTyp.Dienstleister: return "Dienstleister";
    case BenutzerTyp.Admin: return "Admin";
    case BenutzerTyp.Monteur: return "Monteur";
    case BenutzerTyp.UnterAdmin: return "Unter-Admin";
    default: return "Unbekannt";
  }
}

export function tankanlagenTypText(value: number | string | null | undefined): string {
    const n = typeof value === "string" ? Number(value) : (value ?? NaN);
    switch (n) {
        case TankanlagenTyp.Tankstelle: return "Tankstelle";
        case TankanlagenTyp.Tankanlage: return "Tankanlage";
        case TankanlagenTyp.Leihtank: return "Leihtank";
        case TankanlagenTyp.Sonstige: return "Sonstige";
        case TankanlagenTyp.Heizöl: return "Heizöl";
        default: return "Unbekannt";
    }
}

export function prioritaetText(value: number | string | null | undefined): string {
    const n = typeof value === "string" ? Number(value) : (value ?? NaN);
    switch (n) {
        case Prioritaet.Niedrig: return "Niedrig";
        case Prioritaet.Mittel: return "Mittel";
        case Prioritaet.Hoch: return "Hoch";
        default: return "Unbekannt";
    }
}

export function ticketStatusText(value: number | string | null | undefined): string {
    const n = typeof value === "string" ? Number(value) : (value ?? NaN);
    switch (n) {
        case TicketStatus.Neu: return "Neu";
        case TicketStatus.Geschlossen: return "Geschlossen";
        case TicketStatus.InBearbeitung: return "in Bearbeitung";
        case TicketStatus.NeuEroeffnet: return "Neu eröffnet";
        case TicketStatus.Aktiv: return "Aktiv";
        case TicketStatus.Inaktiv: return "Inaktiv";
        case TicketStatus.Geloescht: return "Gelöscht";
        default: return "Unbekannt";
    }
}

export function mailArtText(value: number | string | null | undefined): string {
    const n = typeof value === "string" ? Number(value) : (value ?? NaN);
    switch (n) {
        case MailArt.TicketErstellt: return "Ticket erstellt";
        case MailArt.TicketGeantwortet: return "Ticket beantwortet";
        case MailArt.TicketGeloescht: return "Ticket gelöscht";
        case MailArt.TicketGeschlossen: return "Ticket geschlossen";
        default: return "Unbekannt";
    }
}

export function dokumentenTypText(value: number | string | null | undefined): string {
    const n = typeof value === "string" ? Number(value) : (value ?? NaN);
    switch (n) {
        case DokumentenTyp.Bestellung: return "Bestellung";
        case DokumentenTyp.Auftragsbestaetigung: return "Auftragsbestätigung";
        case DokumentenTyp.Monteurauftrag: return "Monteurauftrag";
        case DokumentenTyp.Pruefbericht: return "Prüfbericht";
        case DokumentenTyp.Sonstiges: return "Sonstiges";
        case DokumentenTyp.Wartungsvertrag: return "Wartungsvertrag";
        case DokumentenTyp.Arbeitsbericht: return "Arbeitsbericht";
        case DokumentenTyp.Angebote: return "Angebote";
        case DokumentenTyp.Auftraege: return "Aufträge";
        default: return "Unbekannt";
    }
}

export function bildTypText(value: number | string | null | undefined): string {
    const n = typeof value === "string" ? Number(value) : (value ?? NaN);
    switch (n) {
        case BildTyp.Tanktechnik: return "Tanktechnik";
        case BildTyp.Shop: return "Shop";
        case BildTyp.Gelaende: return "Gelände";
        case BildTyp.Waschtechnik: return "Wasshtechnik";
        case BildTyp.Sonstiges: return "Sonstiges";
        case BildTyp.Elektrik: return "Elektrik";
        default: return "Unbekannt";
    }
}

export function schnittstellenProtokollText(value: number | string | null | undefined): string {
    const n = typeof value === "string" ? Number(value) : (value ?? NaN);
    switch (n) {
        case SchnittstellenProtokoll.Unbekannt: return "Unbekannt";
        case SchnittstellenProtokoll.ER3: return "ER3";
        case SchnittstellenProtokoll.TwoWire: return "2-Wire";
        case SchnittstellenProtokoll.Impuls: return "Impuls";
        default: return "Unbekannt";
    }
}